module.exports = __webpack_public_path__ + "img/17a)NH Hotel-Frankfurt.jpg";